import httpClient from '../utils/http'
import { handleResponseAsync } from '../utils/HelperUtils'
import { normalize } from 'normalizr'
import { bizNumbersSchema } from './../entities/schema'
import _ from 'lodash'

export const bizNumbersService = {
    getBizNumbers,
    getActiveBizNumber,
    updateBizNumber,
    updateActiveBizNumber,
    addBizNumber,
    removeBizNumberById,
}

function convertViewModelList(data) {
    const bizNumbersListSchema = [bizNumbersSchema]
    const normalizedData = normalize(data, bizNumbersListSchema)
    return normalizedData.entities
}

function convertViewModel(data) {
    const normalizedData = normalize(data, bizNumbersSchema)
    return normalizedData.entities
}

function convertById(data) {
    return data.id
}

function getBizNumbers() {
    const url = '/api/biznumbers'

    return httpClient
        .get(url)
        .then(handleResponseAsync)
        // .then(res => convertViewModelList(res.data))
}

function getActiveBizNumber() {
    const url = '/api/activeBizNumber'

    return httpClient
        .get(url)
        .then(handleResponseAsync)
        // .then(res => convertViewModelList(res.data))
}

function updateActiveBizNumber(data) {
    const url = '/api/activeBizNumber'

    return httpClient
        .put(url, data)
        .then(handleResponseAsync)
        // .then(res => convertViewModel(_.first(res.data)))
}

function updateBizNumber(data) {
    const url = '/api/biznumbers'

    return httpClient
        .put(url, data)
        .then(handleResponseAsync)
        // .then(res => convertViewModel(_.first(res.data)))
}

function addBizNumber(data) {
    const url = '/api/biznumbers'

    // const config = {
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    // }
    return httpClient
        .post(url, data)
        .then(handleResponseAsync)
        .then(res => convertViewModel(res.data))
}

function removeBizNumberById(id) {
    const url = `/api/biznumbers/${id}`

    // const config = {
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    // }
    return httpClient
        .delete(url)
        .then(handleResponseAsync)
        .then(res => convertById(res.data))
}
